import React from 'react';
import { TcsmNotFoundPage } from '../../models/tcsm-page-models';
import { MainContent } from '../layout/main-content-container';
import { PageContainer } from '../layout/page-container';
import { PageHeader } from '../layout/page-header';
import { WysiwygWithReactLink } from '../wysiwyg-with-react-link';

interface Props {
    pageData: TcsmNotFoundPage,
}

export const TcsmNotFoundPageView = (props: Props) => {
    const { pageData } = props;

    return (
        <PageContainer>
            <MainContent>
                <PageHeader
                    headerText={pageData?.pageTitle}
                />                               
                <WysiwygWithReactLink content={pageData?.mainContent} />
            </MainContent>            
        </PageContainer>
    );
};
